import { ref, shallowRef } from 'vue'

const HeaderComponent = shallowRef(null)
const headerComponentProps = ref({})

export const useMainHeader = () => {
  const setHeaderComponent = (component, props = {}) => {
    HeaderComponent.value = component
    headerComponentProps.value = props
  }

  const clearHeaderComponent = () => {
    HeaderComponent.value = null
  }
  return {
    HeaderComponent,
    headerComponentProps,
    setHeaderComponent,
    clearHeaderComponent
  }
}
